export const MAX_DAY_COUNT = 60;
export const DEFAULT_DAY_COUNT = 30;
export const DEFAULT_SUBSCRIPTION_PERIOD = 1;
export var OrderFlowText;
(function (OrderFlowText) {
    OrderFlowText["SubscriptionDiscountLabelText"] = "Subscription Discount";
    OrderFlowText["SubscriptionPeriodLabelText"] = "Renewal Period";
    OrderFlowText["DraftOrder"] = "Draft Order";
})(OrderFlowText || (OrderFlowText = {}));
export var PaperSettings;
(function (PaperSettings) {
    PaperSettings[PaperSettings["NoPaper"] = 1] = "NoPaper";
    PaperSettings[PaperSettings["StartNewPaper"] = 2] = "StartNewPaper";
    PaperSettings[PaperSettings["ContinuePaper"] = 3] = "ContinuePaper";
})(PaperSettings || (PaperSettings = {}));
export var RecipeIngredientCompatibility;
(function (RecipeIngredientCompatibility) {
    //Recipes are a match when they fit the customers recipe type/omissions
    RecipeIngredientCompatibility[RecipeIngredientCompatibility["MATCH"] = 1] = "MATCH";
    //User selected customizations
    RecipeIngredientCompatibility[RecipeIngredientCompatibility["CUSTOMIZED"] = 2] = "CUSTOMIZED";
    //Recipes are modified when ingredients are substituted automatically
    RecipeIngredientCompatibility[RecipeIngredientCompatibility["MODIFIED"] = 3] = "MODIFIED";
    // A conflict occurs when an ingredient is a user-selected omission.
    // Recipes are a conflict when they do not align with the selected recipe type or omissions.
    RecipeIngredientCompatibility[RecipeIngredientCompatibility["CONFLICT"] = 4] = "CONFLICT";
})(RecipeIngredientCompatibility || (RecipeIngredientCompatibility = {}));
export var MessageType;
(function (MessageType) {
    MessageType[MessageType["Info"] = 0] = "Info";
    MessageType[MessageType["Error"] = 10] = "Error";
    MessageType[MessageType["Success"] = 20] = "Success";
})(MessageType || (MessageType = {}));
export var GUID;
(function (GUID) {
    GUID["EMPTY"] = "00000000-0000-0000-0000-000000000000";
})(GUID || (GUID = {}));
export var DisplayMode;
(function (DisplayMode) {
    DisplayMode[DisplayMode["Button"] = 1] = "Button";
    DisplayMode[DisplayMode["Card"] = 2] = "Card";
})(DisplayMode || (DisplayMode = {}));
export var ImageDisplay;
(function (ImageDisplay) {
    ImageDisplay[ImageDisplay["DetailsOverlay"] = 0] = "DetailsOverlay";
    ImageDisplay[ImageDisplay["ImagePinnedToTop"] = 10] = "ImagePinnedToTop";
    ImageDisplay[ImageDisplay["NoImage"] = 20] = "NoImage";
})(ImageDisplay || (ImageDisplay = {}));
export var NameDisplay;
(function (NameDisplay) {
    NameDisplay[NameDisplay["ShortName"] = 0] = "ShortName";
    NameDisplay[NameDisplay["LongName"] = 10] = "LongName";
})(NameDisplay || (NameDisplay = {}));
export var CouponType;
(function (CouponType) {
    CouponType["Dollars"] = "Dollars";
    CouponType["Percent"] = "Percent";
    CouponType["PerMeal"] = "PerMeal";
})(CouponType || (CouponType = {}));
export var AdjustmentType;
(function (AdjustmentType) {
    AdjustmentType[AdjustmentType["Discount"] = 0] = "Discount";
    AdjustmentType[AdjustmentType["Surcharge"] = 1] = "Surcharge";
})(AdjustmentType || (AdjustmentType = {}));
export var ModuleNames;
(function (ModuleNames) {
    ModuleNames["START_DATE"] = "Start Date";
    ModuleNames["HTML"] = "HTML";
    ModuleNames["DAYS_OF_WEEK"] = "Days of Week";
    ModuleNames["MEAL_QUANTITY"] = "Meal Quantity";
    ModuleNames["OMISSION"] = "Omission";
    ModuleNames["RECIPE_TYPE"] = "Recipe Type";
    ModuleNames["RECIPE"] = "Recipe";
    ModuleNames["DAY_FILTER"] = "Day Filter";
    ModuleNames["SUBSCRIPTION"] = "Subscription";
    ModuleNames["DAY_QUANTITY"] = "Day Quantity";
    ModuleNames["DEBUG"] = "Debug";
    ModuleNames["REQUIREMENTS"] = "Requirements";
    ModuleNames["PRODUCT"] = "Product";
    ModuleNames["RECIPE_SELECTION_WARNING"] = "Recipe Selection Warning";
    ModuleNames["MEAL_SIZE"] = "Meal Size";
    ModuleNames["MEAL_BUNDLE_CHOOSER"] = "Meal Bundle Chooser";
    ModuleNames["RECIPE_FILTER"] = "Recipe Filter";
    ModuleNames["QUESTIONS"] = "Questions";
    ModuleNames["MARKDOWN"] = "Markdown";
    ModuleNames["WEEK_QUANTITY"] = "Week Quantity";
    ModuleNames["BANNER"] = "Banner";
})(ModuleNames || (ModuleNames = {}));
//Copied from the database
export var ModuleTypes;
(function (ModuleTypes) {
    ModuleTypes[ModuleTypes["START_DATE"] = 1] = "START_DATE";
    ModuleTypes[ModuleTypes["HTML"] = 2] = "HTML";
    ModuleTypes[ModuleTypes["DAYS_OF_WEEK"] = 3] = "DAYS_OF_WEEK";
    ModuleTypes[ModuleTypes["MEAL_QUANTITY"] = 4] = "MEAL_QUANTITY";
    ModuleTypes[ModuleTypes["OMISSION"] = 5] = "OMISSION";
    ModuleTypes[ModuleTypes["RECIPE_TYPE"] = 6] = "RECIPE_TYPE";
    ModuleTypes[ModuleTypes["RECIPE"] = 7] = "RECIPE";
    ModuleTypes[ModuleTypes["DAY_FILTER"] = 8] = "DAY_FILTER";
    ModuleTypes[ModuleTypes["SUBSCRIPTION"] = 10] = "SUBSCRIPTION";
    ModuleTypes[ModuleTypes["DAY_QUANTITY"] = 11] = "DAY_QUANTITY";
    ModuleTypes[ModuleTypes["DEBUG"] = 12] = "DEBUG";
    ModuleTypes[ModuleTypes["REQUIREMENTS"] = 13] = "REQUIREMENTS";
    ModuleTypes[ModuleTypes["PRODUCT"] = 14] = "PRODUCT";
    ModuleTypes[ModuleTypes["RECIPE_SELECTION_WARNING"] = 15] = "RECIPE_SELECTION_WARNING";
    ModuleTypes[ModuleTypes["MEAL_SIZE"] = 16] = "MEAL_SIZE";
    ModuleTypes[ModuleTypes["MEAL_BUNDLE_CHOOSER"] = 17] = "MEAL_BUNDLE_CHOOSER";
    ModuleTypes[ModuleTypes["RECIPE_FILTER"] = 18] = "RECIPE_FILTER";
    ModuleTypes[ModuleTypes["QUESTIONS"] = 19] = "QUESTIONS";
    ModuleTypes[ModuleTypes["MARKDOWN"] = 20] = "MARKDOWN";
    ModuleTypes[ModuleTypes["WEEK_QUANTITY"] = 21] = "WEEK_QUANTITY";
    ModuleTypes[ModuleTypes["BANNER"] = 22] = "BANNER";
})(ModuleTypes || (ModuleTypes = {}));
var OverLappingOrdersMode;
(function (OverLappingOrdersMode) {
    OverLappingOrdersMode[OverLappingOrdersMode["None"] = 0] = "None";
    OverLappingOrdersMode[OverLappingOrdersMode["SoftReject"] = 10] = "SoftReject";
    OverLappingOrdersMode[OverLappingOrdersMode["HardReject"] = 20] = "HardReject";
})(OverLappingOrdersMode || (OverLappingOrdersMode = {}));
export var RecipeIngredientReplacementMode;
(function (RecipeIngredientReplacementMode) {
    RecipeIngredientReplacementMode[RecipeIngredientReplacementMode["DISABLED"] = 0] = "DISABLED";
    RecipeIngredientReplacementMode[RecipeIngredientReplacementMode["ENABLED"] = 1] = "ENABLED";
})(RecipeIngredientReplacementMode || (RecipeIngredientReplacementMode = {}));
export var RecipeTypeSelectionMode;
(function (RecipeTypeSelectionMode) {
    RecipeTypeSelectionMode[RecipeTypeSelectionMode["None"] = 0] = "None";
    //Filter mode only filters recipes that display
    RecipeTypeSelectionMode[RecipeTypeSelectionMode["Filter"] = 1] = "Filter";
    //Selection mode adds the recipe to the order
    RecipeTypeSelectionMode[RecipeTypeSelectionMode["Selection"] = 2] = "Selection";
    //Filter and selection filter recipes and adds recipe type to the order
    RecipeTypeSelectionMode[RecipeTypeSelectionMode["FilterAndSelection"] = 3] = "FilterAndSelection";
})(RecipeTypeSelectionMode || (RecipeTypeSelectionMode = {}));
export var SubscriptionPeriodSetting;
(function (SubscriptionPeriodSetting) {
    //Use configured subscription period
    SubscriptionPeriodSetting[SubscriptionPeriodSetting["MATCH_SUBSCRIPTION_PERIOD"] = 1] = "MATCH_SUBSCRIPTION_PERIOD";
    //Subscription period is set on the Day Quantity Module
    SubscriptionPeriodSetting[SubscriptionPeriodSetting["MATCH_ORDER_PERIOD"] = 2] = "MATCH_ORDER_PERIOD";
})(SubscriptionPeriodSetting || (SubscriptionPeriodSetting = {}));
export var RecipeSelectionType;
(function (RecipeSelectionType) {
    RecipeSelectionType[RecipeSelectionType["AddMeals"] = 0] = "AddMeals";
    RecipeSelectionType[RecipeSelectionType["AssignRecipes"] = 10] = "AssignRecipes";
    RecipeSelectionType[RecipeSelectionType["Both"] = 20] = "Both";
    RecipeSelectionType[RecipeSelectionType["None"] = 30] = "None";
})(RecipeSelectionType || (RecipeSelectionType = {}));
//TODO: What are valid threshold values for a discount?
var ThresholdType;
(function (ThresholdType) {
    ThresholdType["MealQty"] = "MealQty";
})(ThresholdType || (ThresholdType = {}));
export var CouponValidation;
(function (CouponValidation) {
    CouponValidation["Valid"] = "Valid";
    CouponValidation["Invalid"] = "Invalid";
    CouponValidation["Expired"] = "Expired";
})(CouponValidation || (CouponValidation = {}));
export var ProductFilterDay;
(function (ProductFilterDay) {
    ProductFilterDay[ProductFilterDay["firstAvailable"] = -1] = "firstAvailable";
    ProductFilterDay[ProductFilterDay["Sunday"] = 0] = "Sunday";
    ProductFilterDay[ProductFilterDay["Monday"] = 1] = "Monday";
    ProductFilterDay[ProductFilterDay["Tuesday"] = 2] = "Tuesday";
    ProductFilterDay[ProductFilterDay["Wednesday"] = 3] = "Wednesday";
    ProductFilterDay[ProductFilterDay["Thursday"] = 4] = "Thursday";
    ProductFilterDay[ProductFilterDay["Friday"] = 5] = "Friday";
    ProductFilterDay[ProductFilterDay["Saturday"] = 6] = "Saturday";
})(ProductFilterDay || (ProductFilterDay = {}));
export var ProductFilterDays;
(function (ProductFilterDays) {
    ProductFilterDays["firstAvailable"] = "firstAvailable";
    ProductFilterDays["Monday"] = "Monday";
    ProductFilterDays["Tuesday"] = "Tuesday";
    ProductFilterDays["Wednesday"] = "Wednesday";
    ProductFilterDays["Thursday"] = "Thursday";
    ProductFilterDays["Friday"] = "Friday";
})(ProductFilterDays || (ProductFilterDays = {}));
export var MealQuantitySelectionMode;
(function (MealQuantitySelectionMode) {
    MealQuantitySelectionMode["SameMealQuantitiesEachMealDay"] = "SameMealQuantitiesEachMealDay";
    MealQuantitySelectionMode["IndividualMealQuantitiesEachMealDay"] = "IndividualMealQuantitiesEachMealDay";
    MealQuantitySelectionMode["Sunday"] = "sunday";
    MealQuantitySelectionMode["Monday"] = "monday";
    MealQuantitySelectionMode["Tuesday"] = "tuesday";
    MealQuantitySelectionMode["Wednesday"] = "wednesday";
    MealQuantitySelectionMode["Thursday"] = "thursday";
    MealQuantitySelectionMode["Friday"] = "friday";
    MealQuantitySelectionMode["Saturday"] = "saturday";
})(MealQuantitySelectionMode || (MealQuantitySelectionMode = {}));
